enum CreateEditionType {
  LimitedEditions = "LimitedEditions",
  UnlimitedEditions = "UnlimitedEditions",
}

export default CreateEditionType;
